import { API_BASE_URL } from "./apiUrl";

export const getImageSrc = (picture) => {
  if (!picture) return "/images/avatar2.png";

  // NEW (Cloudinary)
  if (picture.url?.startsWith("http")) {
    return picture.url;
  }

  // OLD (local uploads fallback)
  if (picture.url) {
    return `${API_BASE_URL}${picture.url}`;
  }

  // VERY OLD (string only)
  if (typeof picture === "string") {
    return picture.startsWith("http")
      ? picture
      : `${API_BASE_URL}${picture}`;
  }

  return "/images/avatar2.png";
};